const safeDecodeURIComponent = (value) => {
    try {
        return decodeURIComponent(value);
    } catch (e) {
        return value;
    }
};

/**
 * Retrieve the url query params and push them into an object
 * which contains { key: value } pairs with the url param name and it's value.
 * @return {Object}
 */
export const getUrlParams = (search = window.location.search) => {
    const urlParams = search.slice(search.indexOf('?') + 1);

    return urlParams.split('&').reduce((acc, next) => {
        const [key, value] = next.split('=');
        const decodedValue = value ? safeDecodeURIComponent(value.replace(/\+/g, '%20')) : null;
        return key
            ? {
                  ...acc,
                  [key]: decodedValue,
              }
            : acc;
    }, {});
};
